import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { AdminHeader } from "./AdminLayout";
import { toast } from "sonner";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setS(r.data)); }, []);
  if (!s) return <div className="h-40 shimmer" />;
  const save = async () => { await api.put("/admin/settings", s); toast.success("Settings saved"); };
  const set = (k, v) => setS({ ...s, [k]: v });
  const setSocial = (k, v) => setS({ ...s, social: { ...(s.social || {}), [k]: v } });

  return (
    <div>
      <AdminHeader title="Settings & Content" subtitle="Store configuration — all content is editable here" action={<button onClick={save} className="btn-primary" data-testid="settings-save">Save Changes</button>} />
      <div className="grid lg:grid-cols-2 gap-6">
        <Card title="Storefront">
          <I label="Brand name" v={s.brand_name} on={(v) => set("brand_name", v)} />
          <I label="Tagline" v={s.tagline} on={(v) => set("tagline", v)} />
          <I label="Announcement bar" v={s.announcement_bar} on={(v) => set("announcement_bar", v)} testid="set-announcement" />
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!s.announcement_enabled} onChange={(e) => set("announcement_enabled", e.target.checked)} className="accent-forest" /> Show announcement bar</label>
        </Card>
        <Card title="Commerce">
          <I label="Free shipping threshold (₹)" type="number" v={s.free_shipping_threshold} on={(v) => set("free_shipping_threshold", Number(v))} testid="set-threshold" />
          <I label="Flat shipping fee (₹)" type="number" v={s.shipping_flat} on={(v) => set("shipping_flat", Number(v))} />
          <I label="Tax rate (%)" type="number" v={s.tax_rate} on={(v) => set("tax_rate", Number(v))} />
          <I label="Pickup pincode (Shiprocket)" v={s.pickup_pincode} on={(v) => set("pickup_pincode", v)} />
        </Card>
        <Card title="Contact">
          <I label="Email" v={s.contact_email} on={(v) => set("contact_email", v)} />
          <I label="Phone" v={s.contact_phone} on={(v) => set("contact_phone", v)} />
          <I label="Address" v={s.contact_address} on={(v) => set("contact_address", v)} />
          <I label="Support hours" v={s.support_hours} on={(v) => set("support_hours", v)} />
        </Card>
        <Card title="Social Links">
          {["instagram", "facebook", "youtube", "linkedin"].map((k) => (
            <I key={k} label={k} v={(s.social || {})[k]} on={(v) => setSocial(k, v)} />
          ))}
        </Card>
        <Card title="SEO Defaults">
          <I label="SEO title" v={s.seo_title} on={(v) => set("seo_title", v)} />
          <div><label className="text-xs uppercase text-forest/55">SEO description</label><textarea className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm" rows={3} value={s.seo_description || ""} onChange={(e) => set("seo_description", e.target.value)} /></div>
        </Card>
        <Card title="Integrations Status">
          <p className="text-sm text-forest/60">Razorpay & Shiprocket run in <strong>demo mode</strong> until credentials are added to backend environment variables. Emails log to server until Resend key is set.</p>
        </Card>
      </div>
    </div>
  );
}
const Card = ({ title, children }) => <div className="bg-white border border-sage/30 rounded-sm p-6 space-y-4"><h3 className="serif text-2xl">{title}</h3>{children}</div>;
const I = ({ label, v, on, type = "text", testid }) => <div><label className="text-xs uppercase text-forest/55">{label}</label><input type={type} value={v ?? ""} onChange={(e) => on(e.target.value)} data-testid={testid} className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm bg-white text-sm" /></div>;
